import useMapEnum from "src/functions/mappers/use-map-enum";
import { DrivingLicence_Enum } from "src/types/enums";

const drivingLicenceOptions = useMapEnum(Object.values(DrivingLicence_Enum))

export default drivingLicenceOptions;
